import { render, staticRenderFns } from "./vip-dialog.vue?vue&type=template&id=4a5674e2&scoped=true&"
import script from "./vip-dialog.vue?vue&type=script&lang=js&"
export * from "./vip-dialog.vue?vue&type=script&lang=js&"
import style0 from "./vip-dialog.vue?vue&type=style&index=0&id=4a5674e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5674e2",
  null
  
)

export default component.exports